import { FormBuilder } from '@angular/forms';
import { Component, OnInit, NgZone, TemplateRef, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from 'src/app/services/storage.service';
import { ConfigService } from 'src/app/services/config.service';
import { WebBookingService } from 'src/app/api/services/web-booking.service';
import { Branch, Customer, GiftVoucher, InvoiceDetailType, Item, ProcessStatus } from 'src/app/api/models/web-booking.models';
import { AppConfigModel } from 'src/app/api/models/base.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppConstants } from 'src/app/app.constants';
import { StringService } from 'src/app/services/string.service';
import { WebGiftVoucherService } from 'src/app/api/services/web-gift-voucher.service';
import { Subject } from 'rxjs';
import { NavigatorService } from 'src/app/services/navigator.service';
import { DateService } from 'src/app/services/date.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/controls/confirmation-dialog/confirmation-dialog.component';
// import { BsLocaleService } from 'ngx-bootstrap';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit, AfterViewInit {

  public token: any;
  public customer: Customer;
  public config: AppConfigModel;

  public pageBanner = '';
  public pageSubTitle = '';
  public pageTitle = 'Book an Appointment';
  public hideFooterAndBanner = false;

  public loadingDescription = 'Loading';
  public showLoadingSvg = true;

  public branch: Branch;
  
  public basketItems: Item[];
  public totalAmount = 0;
  public cartUpdateTrigger: Subject<any> = new Subject();
  public hasGiftVoucherItem: boolean;
  public hasBookingItem: boolean;
  public isPassSeven: boolean;

  public alreadyAnswer: boolean;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public ngZone: NgZone,
    public configService: ConfigService,
    public storageService: StorageService,
    public webBookingService: WebBookingService,
    public webGiftVoucherService: WebGiftVoucherService,    
    public modalService: BsModalService,
    public modalService1: BsModalService,
    public spinner: NgxSpinnerService,
    public stringService: StringService,
    public navigatorService: NavigatorService,
    public dateService: DateService,
    public dialog: MatDialog,
    // public localeService: BsLocaleService
  ) {
    this.config = this.configService.config;
    // this.localeService.use(this.configService.config.locale.toLowerCase());
  }

  ngAfterViewInit(): void {
    // setTimeout(() => { this.openModal(this.covidUpdate); }, 100);
  }

  ngOnInit(): void {
  }


  gotoProfile(): void {

  }

  gotoChangePassword(): void {

  }

  gotoLogout(): void {

  }


  delete(index) {
    const deletedItem = this.basketItems.splice(index, 1);
    if (deletedItem[0].invoiceDetailType == InvoiceDetailType.Service) {
      this.cancelAppointment(deletedItem[0].appointmentId);
    }
    this.reCompute();
  }

  reCompute()
  {
    this.storageService.setItem(AppConstants.GiftVoucherSelectedVouchers, JSON.stringify(this.basketItems));
    this.totalAmount = 0;
    this.hasGiftVoucherItem = false;
    this.hasBookingItem = false;
    if(this.basketItems!=null)
    {
      this.basketItems.forEach((e) => {
        this.totalAmount += e.fee;
        if(e.invoiceDetailType == InvoiceDetailType.GiftVoucher)
        {
          this.hasGiftVoucherItem = true;
        }
        if(e.invoiceDetailType == InvoiceDetailType.Service)
        {
          this.hasBookingItem = true;
          if(this.stringService.isNotEmpty(e.startTime))
          {
            const selectedDate = this.dateService.getNewDate(e.startTime);
            this.isPassSeven = selectedDate.getHours() >= 19;
          }
        }
      });
    }
    
    if (this.basketItems == null || this.basketItems.length === 0) {
      this.storageService.setItem(AppConstants.GiftVoucherProcessStatus, ProcessStatus.SelectGiftVoucher.toString());
      this.storageService.removeItem(AppConstants.GiftVoucherPendingTransactionHeader);
      this.router.navigate(['']);
    } else if (this.router.url === '/checkout') {
      this.cartUpdateTrigger.next('go');
    }
  }

  cancelAppointment(appointmentId): void {
    const m = { appointmentId: appointmentId };
    this.webBookingService.CancelAppointment(m)
      .subscribe(data => { }, error => { });
  }

  compute() {
    this.totalAmount = 0;
    this.basketItems.forEach((e) => {
      this.totalAmount += e.fee;
      if(e.invoiceDetailType == InvoiceDetailType.GiftVoucher)
      {
        this.hasGiftVoucherItem = true;
      }
      if(e.invoiceDetailType == InvoiceDetailType.Service)
      {
        this.hasBookingItem = true;
      }
    });
  }

  addLogs(command, message): void {
    if (this.branch != null && this.customer != null) {
      setTimeout(() => {
        const model = {
          branchId: this.branch.branchId,
          customerId: this.customer.customerId,
          command,
          message,
        };
        this.webGiftVoucherService.AddLogs(model).subscribe((data) => { }, (error) => { });
      }, 1000);
    }
  }

  showErrorMessage(data: any): void {
    const message = this.getBadRequest(data);
    this.toastr.error(message, 'Error', { timeOut: 3000 });
  }

  showInfoMessage(message: string): void {
    this.toastr.info(message, 'Info', { timeOut: 3000 });
  }

  showSuccessMessage(message: string): void {
    this.toastr.success(message, 'Success', { timeOut: 3000 });
  }

  getBadRequest(data: any): string {
    let message = '';
    if (data != null && data._body != null) {
      const body = JSON.parse(data._body);
      if (body.message != null) { message = body.message; }
      if (body.error_description != null) { message = body.error_description; }
    }
    else if (data.error != null && data.error !== undefined) {
      if (data.error.message != null) { message = data.error.message; }
      if (data.error.error_description != null) { message = data.error.error_description; }
    }
    else {
      message = data;
    }
    return message;
  }

  getParameterByName(name: string, url: string): string {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return '';
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  
  showMessageBox(message: string): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      maxWidth: '400px',
      data: { 
        action: '0',
        description: message,
        showConfirm: false
      },
    });
    dialogRef.afterClosed().subscribe((result: { action: string; } | null) => {
      console.log(result);
      if (result != null) {
        if (result.action == '1') {
        }
      }
    });
  }

  showConfirmDialog(message: string, confirmText: string, titleText: string): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      maxWidth: '400px',
      closeOnNavigation: false,
      disableClose: true,
      data: { 
        action: '0',
        description: message,
        showConfirm: true,
        confirmText: confirmText,
        hideClose: true,
        showTickAgree: true,
        title: titleText
      },
    });
    dialogRef.afterClosed().subscribe((result: { action: string; } | null) => {
      console.log(result);
      if (result != null) {
        if (result.action == '1') {
        }
      }
    });
  }
}
